import React, { useEffect, useState } from 'react';
import styles from './PerfilEntregador.module.css';
import { FaUser } from 'react-icons/fa';
import HeaderPageEquipe from '../../operador/components/HeaderPageEquipe';
import FooterOpcoes from '../../cliente/components/FooterOpcoes';
import { logout } from '../../../shared/utils/auth';

const API_URL = process.env.REACT_APP_API_URL;

const PerfilEntregador = () => {
  const nomeEstabelecimento = localStorage.getItem('nomeEstabelecimento');
  const [funcionario, setFuncionario] = useState({ nome: '', email: '', telefone: '' });
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    const buscarDados = async () => {
      try {
        const idFuncionario = localStorage.getItem('id_funcionario');
        if (!idFuncionario) return;

        const response = await fetch(`${API_URL}/funcionario/${idFuncionario}`);
        if (!response.ok) throw new Error('Erro ao buscar dados do funcionário');

        const data = await response.json();
        setFuncionario(data);
      } catch (error) {
        console.error('Erro ao carregar perfil do entregador:', error);
      } finally {
        setCarregando(false);
      }
    };

    buscarDados();
  }, []);

  return (
    <div className={styles.container}>
      <HeaderPageEquipe
        nomeEstabelecimento={nomeEstabelecimento}
        nomePage="Meu Perfil"
        perfilPath="/equipe/entregador/perfil"
      />

      <div className={styles.contentWrapper}>
        {carregando ? (
          <p className={styles.carregando}>Carregando...</p>
        ) : (
          <>
            <section className={styles.cardPerfil}>
              <div className={styles.avatarPlaceholder}>
                <FaUser />
              </div>
              <div className={styles.infoBasica}>
                <h2>{funcionario.nome}</h2>
                <p className={styles.badgeFuncao}>Entregador</p>
              </div>
            </section>

            <section className={styles.dadosPerfil}>
              <h3>Informações pessoais</h3>
              <div className={styles.camposPerfil}>
                <div className={styles.campo}>
                  <label>Email</label>
                  <p>{funcionario.email}</p>
                </div>
                <div className={styles.campo}>
                  <label>Telefone</label>
                  <p>{funcionario.telefone || 'Não informado'}</p>
                </div>
              </div>
              <p className={styles.avisoSomenteLeitura}>Para alterar esses dados, fale com a administração do estabelecimento.</p>
            </section>

            <section className={styles.sessao}>
              <button className={styles.btnSair} onClick={logout}>
                Sair da conta
              </button>
            </section>
          </>
        )}
      </div>

      <FooterOpcoes typeView="entregador" />
    </div>
  );
};

export default PerfilEntregador;
